/**
 * Escape special characters in an OpenSearch/Elasticsearch query_string query.
 *
 * The query_string query parser treats these characters as operators:
 * + - = && || > < ! ( ) { } [ ] ^ " ~ * ? : \ /
 *
 * Unescaped colons are particularly problematic as they get interpreted
 * as field:value syntax (e.g., "Search target: abc" becomes field "target").
 *
 * @see https://opensearch.org/docs/latest/query-dsl/full-text/query-string/#reserved-characters
 */
export const escapeQueryString = (query: string): string =>
  query.replace(/([+\-=&|><!()\{\}\[\]^"~*?:\\/])/g, '\\$1')
